export default __webpack_public_path__ + "static/media/coinBurstwinSound.75bdab2f.mp3";